<template>
    <ListeCodification @refreshList="fetchCodification"/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeCodification from "@/components/GesCom/Codification/ListeCodification.vue";

    export default defineComponent({
      name: "ListeCodificationPage",
      components: {
        
        ListeCodification,
      },
    });
  </script>